import { render, staticRenderFns } from "./FloatingContact.vue?vue&type=template&id=203ae390&scoped=true&"
import script from "./FloatingContact.vue?vue&type=script&lang=js&"
export * from "./FloatingContact.vue?vue&type=script&lang=js&"
import style0 from "./FloatingContact.vue?vue&type=style&index=0&id=203ae390&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203ae390",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
